import React from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import styles from './footer-xsci.module.css'
// import responsive from "./footer-xsci-responsive.module.css";
import {faEnvelope, faLocationDot, faPhone} from "@fortawesome/free-solid-svg-icons";
// import {useTranslation} from "react-i18next";

const ContactSection = () => {
    // const {t, i18n} = useTranslation();


    return (

        <div className={`col-md-3 col-12 my-sm-0 mt-5 ${styles.section_container}`}>
            <ul className="list-unstyled">
                <li className={`mt-md-3 mt-4 ${styles.section_title}`}>Contact</li>
                <li className={styles.section_li}>
                    <a href="mailto:aquaticsvice@gmail.com">
                        <FontAwesomeIcon
                            icon={faEnvelope}
                            style={{
                                fontSize: "18px",
                                color: "lightgray",
                                cursor: "pointer",
                                paddingRight: "10px",
                            }}/>
                    </a>
                    aquaticsvice@gmail.com
                </li>
                <li className={styles.section_li}>
                    <a href="tel:514-545-9049" className="phone-link" style={{color: "white"}}>
                        <FontAwesomeIcon
                            icon={faPhone}
                            style={{
                                fontSize: "18px",
                                color: "lightgray",
                                cursor: "pointer",
                                paddingRight: "10px"
                            }}
                        />
                        514-545-9049
                    </a>
                </li>
                {/*<li className={styles.section_li}><FontAwesomeIcon*/}
                {/*    icon={faLocationDot}*/}
                {/*    style={{*/}
                {/*        fontSize: "18px",*/}
                {/*        color: "#194A85",*/}
                {/*        cursor: "pointer",*/}
                {/*        paddingRight: "10px"*/}
                {/*    }}/>*/}
                {/*    Sainte-Catherine, Quebec J5C 1Y5.*/}
                {/*</li>*/}
                <li className={styles.section_li}>
                    <a
                        href="https://www.google.com/maps/search/?api=1&query=Sainte-Catherine+Quebec+J5C+1Y5"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{color: "white"}}
                    >
                        <FontAwesomeIcon
                            icon={faLocationDot}
                            style={{
                                fontSize: "18px",
                                color: "lightgray",
                                cursor: "pointer",
                                paddingRight: "10px"
                            }}
                        />
                        Sainte-Catherine, Quebec J5C 1Y5
                    </a>
                </li>
            </ul>
        </div>

    );
};

export default ContactSection;